module.exports = __webpack_public_path__ + "static/media/footer-logo.073f70af.png";